import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import { getFeatureFlagSummary, isPublicMockEnabled } from '@/config/featureFlags';
import '@/i18n/i18n';
import '@/styles/globals.scss';

import App from './App.tsx';

const bootstrap = async (): Promise<void> => {
  if (__DEV__ && isPublicMockEnabled()) {
    const { handlers } = await import('@/mocks/handlers');
    const { worker } = await import('@/mocks/browser');

    if (handlers.length === 0) {
      const activeModes = getFeatureFlagSummary();
      console.warn(
        `[mock-mode] MSW worker started with 0 handlers. Current mock mode relies on feature-level mock branches, not network interception. (public=${activeModes.public}, admin=${activeModes.admin})`,
      );
    }

    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element (#root) not found');

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void bootstrap();
